import { Module } from 'vuex'
import axios from 'axios'
import { BASE_API_URL } from '@/config'

export interface Warning {
  id: number
  name: string
  description: string
}
export type AddWarning = Pick<Warning, 'name' | 'description'>
export type EditWarning = Warning
export interface WarningStore {
  warnings: Warning[]
}

export const warningStore: Module<WarningStore, {}> = {
  namespaced: true,
  state: () => ({
    warnings: []
  }),
  mutations: {
    getAll(state, payload: Warning[]) {
      state.warnings = payload
    }
  },
  actions: {
    async getAll({ commit }) {
      const { data } = await axios(`${BASE_API_URL}/warning`)
      commit('getAll', data)
    },
    async add({ dispatch }, payload: AddWarning) {
      const { data } = await axios.post(`${BASE_API_URL}/warning`, payload)
      await dispatch('getAll')
      return data
    },
    async edit({ dispatch }, { id, ...warning }: EditWarning) {
      const { data } = await axios.put(`${BASE_API_URL}/warning/${id}`, warning)
      await dispatch('getAll')
      return data
    },
    async get(_, id: string) {
      const { data } = await axios.get(`${BASE_API_URL}/warning/${id}`)
      return data
    }
  },
  getters: {
    warnings: state => state.warnings
  }
}
